'use strict';
import isFunction from 'lodash/isFunction';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/delay';
import 'rxjs/add/observable/merge';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {getDomainLink, getLink} from '../../../core-utilities/domain/ReduxUtils';
import {shouldStateUpdate} from '../../../core-utilities/react-utils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {PERSONNEL_COLLECTION} from '../../domain/config';
import {Avatar} from '../../../files/components/Avatar';
import {PersonItemView} from './PersonItemView';
import {logger} from '../logger';


export class PersonItemComponent extends Component {
  static propTypes = {
    modelId: T.string,
    modelCollection: T.string,
    namePlaceholder: T.string,
    onClick: T.func,

    className: T.string,
    roleClass: T.string,
    rtl: T.bool,
    showName: T.bool,

    avatarClass: T.string,
    placeholderTitle: T.string,
    avatarWidth: T.number,
    avatarHeight: T.number,
    avatarDisplayWidth: T.number,
    avatarDisplayHeight: T.number,

    init: T.bool,
  };

  static defaultProps = {
    avatarWidth: 44,
    avatarHeight: 44,
    modelCollection: PERSONNEL_COLLECTION,

    init: true,
  };

  static $inject = [
    'PersonnelService',
    'userPresenceService',
  ];

  constructor(props) {
    super(props);
    this.model = {id: null, collection: null};
    this.state = {
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.stopPropagation();
    if (isFunction(this.props.onClick)) {
      this.props.onClick(event);
    }
  }

  render() {
    // TODO(Brandon): We may need to adjust the class(es) passed into Avatar.
    // Its kind of a mess right now since originally
    //  - the task-assignment directive used "task-cat-progress task-assignee user-icon-small
    //  - the person directive used "icon user-icon"
    // These don't seem to be playing nice with each other.
    // Is there a way we provide an avatarClass prop in TaskAssignmentComponent that causes the avatar to be smaller, like is was originally?
    // Beyond that, preferably leave all of the positioning stuff up to PersonItemView?
    // Keep in nmind we still have to handle authorPresence CSS class and its positioning of the dot to show user presence
    return (
      <PersonItemView
        className={this.props.className}
        roleClass={this.props.roleClass}
        rtl={this.props.rtl}
        showName={this.props.showName}
        onClick={this.handleClick}

        name={this.state.model ? this.state.name : this.props.namePlaceholder}
        role={this.state.role}

        avatar={
          <Avatar
            className={classNames(this.props.avatarClass, PersonItemView.avatarClass, this.state.authorPresence)}
            model={this.state.model}
            placeholderTitle={this.props.placeholderTitle}
            targetWidth={this.props.avatarWidth}
            targetHeight={this.props.avatarHeight}
            displayWidth={this.props.avatarDisplayWidth}
            displayHeight={this.props.avatarDisplayHeight}
            cropTarget={true}
            init={this.props.init}
          />
        }
      />
    );
  }

  withNextModel(props) {
    const id = props.modelId || null;
    const collection = props.modelCollection || null;
    if (this.modelLink$ && (this.model.id !== id || this.model.collection !== collection)) {
      this.model = {id, collection};
      this.modelLink$.next(this.model);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.withNextModel(nextProps);
  }

  componentDidMount() {
    this.modelLink$ = new ReplaySubject(1);
    this.modelLink$.next(this.props);

    if (this.props.init) {
      this.initData();
    }
  }

  initData() {
    const model$ = this.modelLink$
      .switchMap(model => Observable
        .merge(
          Observable.of({
            authorPresence: '',
            model: null,
          }),
          PersonItemComponent.buildModel$(model.id, model.collection)),
      );

    this.stateSubscription = model$
      .catch(epicErrorHandler(logger, 'state$'))
      .subscribe(nextState => {
        if (shouldStateUpdate(this.state, nextState)) {
          this.setState(nextState);
        }
      });

    this.withNextModel(this.props);
  }

  componentWillUnmount() {
    this.props$ = null;
    this.stateSubscription && this.stateSubscription.unsubscribe();
  }

  // get person

  static buildModel$(newId, newCollection) {
    return Observable
      .fromPromise(PersonItemComponent.dependencies.PersonnelService.getPersonAsync(newId, newCollection)
        .then(model => model && newCollection === PERSONNEL_COLLECTION && getLink(model, 'aliasFor').id
          ? getDomainLink(model, 'aliasFor')
          : Promise.resolve(model))
      )
      .switchMap(model => Observable.merge(
        Observable.of({role: model ? model.role : ''}),
        PersonItemComponent.buildDelegateFromAlias$(model),
      ));
  }

  static buildDelegateFromAlias$(model) {
    const model$ = PersonItemComponent.observeModel(model)
      .map(model => ({model, name: model ? model.toString() : ''}));
    return model && model.isUser()
      ? Observable.merge(
        model$,
        PersonItemComponent.getPresence$(model),
      )
      : model$;
  }

  static observeModel(model) {
    return model && isFunction(model.$observe)
      ? model.$observe()
      : Observable.of(model);
  }

  static getPresence$(assignedTo) {
    return PersonItemComponent.dependencies.userPresenceService.getPresence$(assignedTo)
      .map(PersonItemComponent.updatePresence);
  }

  static updatePresence(state) {
    return {authorPresence: PersonItemView.getPresenceClass(state)};
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/components/PersonItem/PersonItemComponent.js